import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const MediaAddUserIcon = createSvgIcon(
  [
    <path
      d="M20.6667 10.6666C20.6667 13.6122 18.2789 16 15.3333 16C12.3878 16 10 13.6122 10 10.6666C10 7.72113 12.3878 5.33331 15.3333 5.33331C18.2789 5.33331 20.6667 7.72113 20.6667 10.6666Z"
      key="0"
    />,
    <path
      d="M10.6667 18C7.72115 18 5.33334 20.3878 5.33334 23.3333V26.5333C5.33334 26.607 5.39303 26.6666 5.46667 26.6666H8.53334C8.60697 26.6666 8.66667 26.607 8.66667 26.5333V24C8.66667 22.5272 9.86058 21.3333 11.3333 21.3333H17.2C17.2736 21.3333 17.3333 21.2736 17.3333 21.2V18.1333C17.3333 18.0597 17.2736 18 17.2 18H10.6667Z"
      key="1"
    />,
    <path
      d="M26 26.6666C26.3682 26.6666 26.6667 26.3682 26.6667 26V24.6666C26.6667 24.2985 26.3682 24 26 24H23.4667C23.393 24 23.3333 23.9403 23.3333 23.8666V21.3333C23.3333 20.9651 23.0349 20.6666 22.6667 20.6666H21.3333C20.9651 20.6666 20.6667 20.9651 20.6667 21.3333V23.8666C20.6667 23.9403 20.607 24 20.5333 24H18C17.6318 24 17.3333 24.2985 17.3333 24.6666V26C17.3333 26.3682 17.6318 26.6666 18 26.6666H20.5333C20.607 26.6666 20.6667 26.7263 20.6667 26.8V29.3333C20.6667 29.7015 20.9651 30 21.3333 30H22.6667C23.0349 30 23.3333 29.7015 23.3333 29.3333V26.8C23.3333 26.7263 23.393 26.6666 23.4667 26.6666H26Z"
      key="2"
    />,
  ],
  'MediaAddUser',
  '0 0 32 32',
);
